import { useMemo } from 'react'
import './App.scss'
import { useDispatch, useSelector } from 'react-redux'
import { type RootState } from './Store/Store'
import { Login } from './Views/Login/Login'
import { CertList } from './Views/Certificate/CertificateList/CertificateList'
import { setDestinationView } from './Store/InterfaceSlice'
import { TopMenu } from './Components/TopMenu/TopMenu'
import { CompanyList } from './Views/Company/CompanyList/CompanyList'
import { CompanyAdd } from './Views/Company/CompanyAdd/CompanyAdd'
import { CompanyEdit } from './Views/Company/CompanyEdit/CompanyEdit'
import { CompanyDetail } from './Views/Company/CompanyDetail/CompanyDetail'
import { CertificateInstanceAdd } from './Views/CertificateInstance/CertificateInstanceAdd/CertificateInstanceAdd'
import { CertificateInstanceEdit } from './Views/CertificateInstance/CertificateInstanceEdit/CertificateInstanceEdit'
import { CertificateInstanceList } from './Views/CertificateInstance/CertificateInstanceList/CertificateInstanceList'
import { CertificateInstanceDetail } from './Views/CertificateInstance/CertificateInstanceDetail/CertificateInstanceDetail'
import { UserList } from './Views/User/UserList/UserList'
import { UserDetail } from './Views/User/UserDetail/UserDetail'
import { UserAdd } from './Views/User/UserAdd/UserAdd'
import { CertificateAdd } from './Views/Certificate/CertificateAdd/CertificateAdd'
import { CertificateEdit } from './Views/Certificate/CertificateEdit/CertificateEdit'
import { CertificateDetail } from './Views/Certificate/CertificateDetail/CertificateDetail'
import { CertificateTypeAdd } from './Views/CertificateType/CertificateTypeAdd/CertificateTypeAdd'
import { CertificateTypeEdit } from './Views/CertificateType/CertificateTypeEdit/CertificateTypeEdit'
import { CertificateTypeList } from './Views/CertificateType/CertificateTypeList/CertificateTypeList'
import { CreateCompanyPopup } from './Overlays/CreateCompanyPopup/CreateCompanyPopup'
import { LoggingList } from './Views/Logging/LoggingList/LoggingList'
import { Reporting } from './Views/Reporting/Reporting'
import { ChangeCompanyVatPopup } from './Overlays/ChangeCompanyVatPopup/ChangeCompanyVatPopup'
import { AnnouncementList } from './Views/Announcement/AnnouncementList/AnnouncementList'
import { AnnouncementAdd } from './Views/Announcement/AnnouncementAdd/AnnouncementAdd'
import { AnnouncementEdit } from './Views/Announcement/AnnouncementEdit/AnnouncementEdit'

function App() {
  const dispatch = useDispatch()
  const activeView = useSelector(
    (state: RootState) => state.interface.activeView
  )
  const detailKey = useSelector((state: RootState) => state.interface.detailKey)
  const activePopup = useSelector(
    (state: RootState) => state.interface.activePopup
  )

  const viewContent = useMemo(() => {
    if (activeView === 'login') return <Login />
    else {
      let resultView = <CertList />
      switch (activeView) {
        case 'certificate-list':
          resultView = <CertList />
          break
        case 'certificate-add':
          resultView = <CertificateAdd />
          break
        case 'certificate-edit':
          resultView = <CertificateEdit uuid={detailKey ?? ''} />
          break
        case 'certificate-detail':
          resultView = <CertificateDetail uuid={detailKey ?? ''} />
          break
        case 'company-list':
          resultView = <CompanyList />
          break
        case 'company-add':
          resultView = <CompanyAdd />
          break
        case 'company-edit':
          resultView = <CompanyEdit vatNumber={detailKey ?? ''} />
          break
        case 'company-detail':
          resultView = <CompanyDetail vatNumber={detailKey ?? ''} />
          break
        case 'certificate-instance-add':
          resultView = <CertificateInstanceAdd />
          break
        case 'certificate-instance-edit':
          resultView = <CertificateInstanceEdit vatNumber={detailKey ?? ''} />
          break
        case 'certificate-instance-list':
          resultView = <CertificateInstanceList />
          break
        case 'certificate-instance-detail':
          resultView = <CertificateInstanceDetail vatNumber={detailKey ?? ''} />
          break
        case 'user-list':
          resultView = <UserList />
          break
        case 'user-detail':
          resultView = <UserDetail email={detailKey ?? ''} />
          break
        case 'user-add':
          resultView = <UserAdd />
          break
        case 'certificate-type-add':
          resultView = <CertificateTypeAdd />
          break
        case 'certificate-type-edit':
          resultView = <CertificateTypeEdit name={detailKey ?? ''} />
          break
        case 'certificate-type-list':
          resultView = <CertificateTypeList />
          break
        case 'logging-list':
          resultView = <LoggingList />
          break
        case 'reporting':
          resultView = <Reporting />
          break
        case 'announcement-list':
          resultView = <AnnouncementList />
          break
        case 'announcement-add':
          resultView = <AnnouncementAdd />
          break
        case 'announcement-edit':
          resultView = <AnnouncementEdit uuid={detailKey ?? ''} />
          break
      }
      return resultView
    }
  }, [activeView, detailKey])

  const popupContent = useMemo(() => {
    if (activePopup?.type == null) return null
    switch (activePopup?.type) {
      case 'company-add': {
        return <CreateCompanyPopup />
      }
      case 'company-change-vat': {
        return <ChangeCompanyVatPopup vatNumber={activePopup.state.vatNumber} />
      }
      default:
        return null
    }
  }, [activePopup])

  return (
    <div className="App">
      <div className="app-header">
        <div className="label-wrapper">
          <img
            src="/img/logo-label.png"
            alt="Label logo"
            className="label-logo"
            onClick={() =>
              dispatch(
                setDestinationView({ destinationView: 'certificate-list' })
              )
            }
          />
        </div>
      </div>
      <div className="top-menu-wrapper">
        <TopMenu />
      </div>
      <div className="content">{viewContent}</div>
      {popupContent}
    </div>
  )
}

export default App
